<template>
<div :class="'editor '+pClass" ref="editor" style="" v-html="actualValue"></div>
</template>
<script>
export default {
  props: ["value", "isNew", "pClass", "placeholder"],
  data: ()=>({
    actualValue: null,
  }),
  mounted() {
    this.actualValue=this.value;
    var config={
      target: this.$refs.editor,
      plugins: [ 'lists', 'link', 'paste', 'table', 'placeholder'],
      link_title: false,
      menubar: false,
      contextmenu: false,
      inline: true,
      valid_styles: {
        "*": "color"
      },
      toolbar: "serifText | bold italic underline strikethrough forecolor | alignleft aligncenter alignright alignjustify | link unlink",
      placeholder: this.placeholder,
      formats: {
        serif: {block: "p", classes: "serif", exact: true},
      },
      style_formats: [
        {title: "Serif", format: "serif"},
      ],
      init_instance_callback: (editor)=>{
        this.initEditor(editor);
      },
      setup: (editor)=>{
        this.setupEditor(editor);
        
        editor.ui.registry.addToggleButton('serifText', {
          icon: 'change-case',
          tooltip: "Toggle serif font",
          onAction: function (_) {
            editor.execCommand('mceToggleFormat', false, 'serif');
          },
          onSetup: function (api) {
            editor.formatter.formatChanged('serif', function (state) {
              api.setActive(state);
            });
          }
        });        
      },
    };
    if (this.pClass=='bquote')
      config.forced_root_block='blockquote';
    if (this.pClass=='ul' || this.pClass=='ol') {
      config.toolbar='bold italic underline strikethrough forecolor | outdent indent | link unlink';
    }
    if (this.pClass=='table') {
      config.toolbar='bold italic underline strikethrough forecolor | alignleft alignright | tablemergecells tablesplitcells tableinsertrowbefore tableinsertrowafter tabledeleterow tableinsertcolbefore tableinsertcolafter tabledeletecol';
      config.table_toolbar=false;
    }
    tinymce.init(config);
  },
  methods: {
    initEditor(editor) {
      this.editor=editor;
      editor.on('change', (e)=>{
        var content=editor.getContent();
        this.$emit("input", content);
      });
      if (this.isNew) {
        setTimeout(()=>{
          editor.focus();
          this.$emit("new-init-done");
        }, 16);
      }
    },
    setupEditor(editor) {
      editor.on('keydown', (e)=>{
//         setTimeout(()=>{
//           var $this=this;
//           var els=editor.$(">*");
//           for(var index=els.length-1;index>0;index--){
//             if (els[index].className=='mce-resizehandle')
//               continue;
//             if (index>0) {
//               $this.$emit("new-block", {content: els[index].outerHTML});
//               els.eq(index).remove();
//             }
//           }
//           var content=editor.getContent();
//           this.$emit("input", content);          
//         }, 10);
      });
      editor.on('paste', (e)=>{
        return;
        setTimeout(()=>{
          var $this=this;
          var els=editor.$(">*");
          for(var index=els.length-1;index>0;index--){
            if (index>0) {
              var args={};
              if (els[index].tagName.toLowerCase()=="p") {
                args.content=els[index].outerHTML;
              } else if (els[index].tagName.toLowerCase()=="blockquote") {
                args.type="blockquote";
                args.content=els[index].outerHTML;
              } else if (els[index].tagName.toLowerCase()=="ul") {
                args.type="ul";
                args.content=els[index].outerHTML;
              } else if (els[index].tagName.toLowerCase()=="li") {
                args.type="li";
                args.content=els[index].outerHTML;
              } else if (els[index].tagName.toLowerCase()=="h1") {
                args.type="h2";
                args.heading=els[index].innerHTML;
              } else if (els[index].tagName.toLowerCase()=="h2") {
                args.type="h2";
                args.heading=els[index].innerHTML;
              } else if (els[index].tagName.toLowerCase()=="h3") {
                args.type="h3";
                args.heading=els[index].innerHTML;
              } else if (els[index].tagName.toLowerCase()=="h4") {
                args.type="h4";
                args.heading=els[index].innerHTML;
              } else if (els[index].tagName.toLowerCase()=="h5") {
                args.type="h4";
                args.heading=els[index].innerHTML;
              } else if (els[index].tagName.toLowerCase()=="h6") {
                args.type="h4";
                args.heading=els[index].innerHTML;
              } else {
                args.content=els[index].outerHTML;
              }
              $this.$emit("new-block", args);
              els.eq(index).remove();
            }
          }
          var content=editor.getContent();
          this.$emit("input", content);          
        }, 10);
      });
    }
  }
}
</script>
